import { render, staticRenderFns } from "./GoalStatusIconGroup.vue?vue&type=template&id=ebaf3156&"
import script from "./GoalStatusIconGroup.vue?vue&type=script&lang=js&"
export * from "./GoalStatusIconGroup.vue?vue&type=script&lang=js&"
import style0 from "./GoalStatusIconGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports